const ACCENTS = ["coral", "gold", "sky", "berry"];

const HIGHLIGHT_RULES = [
  { pattern: /safe|supportive|welcoming/i, title: "Safe & supportive" },
  { pattern: /fun|engag|high-energy|have fun/i, title: "Fun & engaging" },
  { pattern: /bond|parent|together/i, title: "Parent-child bonding" },
  { pattern: /social|team/i, title: "Social connection" },
  { pattern: /confiden|self-esteem/i, title: "Build confidence" },
  { pattern: /motor|coordination|physical/i, title: "Motor skills" },
  { pattern: /skill|learn|train/i, title: "Skill building" },
  { pattern: /warm.?up|cool.?down|structure|class begins/i, title: "Structured class flow" },
  { pattern: /equip|apparatus|explor/i, title: "Explore the gym" },
  { pattern: /strength|flexib/i, title: "Strength & flexibility" },
  { pattern: /boys and girls|every child|all levels/i, title: "For every child" },
];

const AGE_PATTERNS = [
  /\bages?\s+(\d+\s*(?:months?|mo|yrs?|years?).*?(?:to|-|–)\s*\d+.*?(?:months?|mo|yrs?|years?))/i,
  /\b(\d+\s*(?:months?|mo)\s*(?:to|-|–)\s*\d+\s*(?:months?|mo|yrs?|years?))/i,
  /\bages?\s+(\d+)\s*(?:to|-|–)\s*(\d+)\s*years?/i,
];

function normalizeWhitespace(text) {
  return text.replace(/\s+/g, " ").trim();
}

function splitSentences(text) {
  return normalizeWhitespace(text)
    .split(/(?<=[.!?])\s+/)
    .map((sentence) => sentence.trim())
    .filter(Boolean);
}

function extractAgeLabel(text) {
  for (const pattern of AGE_PATTERNS) {
    const match = text.match(pattern);
    if (!match) continue;

    const raw = match[1] || match[0];
    const cleaned = normalizeWhitespace(raw.replace(/^ages?\s+/i, ""));
    return cleaned ? `Ages ${cleaned}` : null;
  }

  return null;
}

function isAgeSentence(sentence) {
  return AGE_PATTERNS.some((pattern) => pattern.test(sentence));
}

function titleForPhrase(phrase) {
  for (const rule of HIGHLIGHT_RULES) {
    if (rule.pattern.test(phrase)) {
      return rule.title;
    }
  }

  const words = phrase.replace(/^and\s+/i, "").split(/\s+/).slice(0, 4);
  const title = words.join(" ");
  return title.charAt(0).toUpperCase() + title.slice(1);
}

function extractListHighlights(sentence) {
  const listMatch = sentence.match(
    /(?:promoting|including|building|developing|improving|designed to|covering)\s+(.+?)(?:\.|$)/i
  );
  if (!listMatch) return null;

  const items = listMatch[1]
    .split(/,\s*(?:and\s+)?/)
    .map((item) => item.trim())
    .filter((item) => item.length > 2);

  if (items.length < 2) return null;

  return items.slice(0, 4).map((item, index) => ({
    title: titleForPhrase(item),
    text: item.charAt(0).toUpperCase() + item.slice(1),
    accent: ACCENTS[index % ACCENTS.length],
  }));
}

function highlightFromSentence(sentence, index) {
  const listHighlights = extractListHighlights(sentence);
  if (listHighlights) return listHighlights;

  return [
    {
      title: titleForPhrase(sentence),
      text: sentence.endsWith(".") ? sentence : `${sentence}.`,
      accent: ACCENTS[index % ACCENTS.length],
    },
  ];
}

export function parseProgramDescription(text) {
  if (!text?.trim()) {
    return { lead: "", highlights: [], ageLabel: null };
  }

  const ageLabel = extractAgeLabel(text);
  const sentences = splitSentences(text);
  const lead = sentences[0] || normalizeWhitespace(text);
  const bodySentences = sentences.slice(1).filter((sentence) => !isAgeSentence(sentence));

  let highlights = bodySentences.flatMap((sentence, index) =>
    highlightFromSentence(sentence, index)
  );

  if (highlights.length === 0 && lead.includes(",")) {
    highlights = extractListHighlights(lead) || [];
  }

  if (highlights.length > 4) {
    highlights = highlights.slice(0, 4);
  }

  return { lead, highlights, ageLabel };
}
